import React, { useState, useMemo, useEffect } from "react";
import ChartistGraph from "react-chartist";
import {
  VictoryPie,
  VictoryTooltip,
  VictoryLabel,
  VictoryBar,
  VictoryLine,
  VictoryChart,
  VictoryAxis,
  VictoryScatter,
  VictoryVoronoiContainer,
  VictoryLegend,
  VictoryGroup,
  VictoryZoomContainer,
  VictoryBrushContainer,
} from "victory";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  Brush,
  BarChart,
  ReferenceLine,
  ReferenceArea,
  Cell,
} from "recharts";
import { VectorMap } from "react-jvectormap";
import {
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  OverlayTrigger,
  Table,
  Tooltip,
  Container,
  Row,
  Col,
  Alert,
  Image,
} from "react-bootstrap";
import moment from "moment";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ColorRing, Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import ReactDatetime from "react-datetime";
import DataTable from "react-data-table-component";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { totalPenyaluran } from "stores";
import { totalNominalLunas } from "stores";
import { totalNominalOngoing } from "stores";
import { totalAllPengajuan } from "stores";
import { getTotalKaryawan } from "stores";
import { totalSimpanan } from "stores";
import { getProfitPugar } from "stores";
import { getPengajuanTrend, getUserTrend } from "stores";
import { getNominalProfitPugar } from "stores";
import { getPengajuanTrack } from "stores";
import dayjs from "dayjs";
import { getRekapSimpanan } from "stores";
import { getRekapAdministrasi } from "stores";
import { getRekapReport } from "stores";
import { syncDashboardCronJobs } from "stores";
import "assets/css/dashboard-utama.css";

function DashboardUtama() {
  const dispatch = useDispatch();
  const reducerDashboard = useSelector((state) => state.dashboardUtamaReducer);
  const formatBulan = (bulan) => {
    return dayjs(bulan).format("MMM 'YY");
  };
  function formatCurrency(amount) {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(amount);
  }
  const [dariTgl, setDariTgl] = React.useState(() => {
    const twoYearsAgo = new Date();
    twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 1);
    twoYearsAgo.setMonth(0);
    twoYearsAgo.setDate(1);
    twoYearsAgo.setHours(0, 0, 0, 0);
    return twoYearsAgo.getTime();
  });
  const [smpTgl, setSmpTgl] = React.useState(new Date());
  const [bulanTahun, setBulanTahun] = React.useState(new Date());
  const [dailyActive, setDailyActive] = React.useState([]);
  const [monthlyJoin, setMonthlyJoin] = React.useState([]);
  const [monthlyExit, setMonthlyExit] = React.useState([]);

  const totalSisaBayarPokokLunas =
    reducerDashboard.ambilTotalNominalLunas.totalPokok;
  const totalSisaBayarAdminLunas =
    reducerDashboard.ambilTotalNominalLunas.totalAdmin;
  const totalJumlahLunas = totalSisaBayarPokokLunas + totalSisaBayarAdminLunas;

  const totalSisaBayarPokok =
    reducerDashboard.ambilTotalNominalOnGoing.totalSisaBayarPokok;
  const totalSisaBayarAdmin =
    reducerDashboard.ambilTotalNominalOnGoing.totalSisaBayarAdmin;
  const totalJumlahOnGoing = totalSisaBayarPokok + totalSisaBayarAdmin;

  const currentYear = new Date().getFullYear();
  const years = [];
  years.push({ value: "semua", label: "Semua" });
  for (let i = currentYear; i >= currentYear - 4; i--) {
    years.push({ value: String(i), label: String(i) });
  }
  const [selectedMonthYear, setSelectedMonthYear] = React.useState({
    start: moment().startOf("year").toDate(), // Jan (default)
    end: moment().endOf("year").toDate(), // Bulan sekarang
  });

  // const [selectedMonthYear, setSelectedMonthYear] = React.useState(new Date());
  // const [startDate, setStartDate] = React.useState(
  //   moment().startOf("year").startOf("month").toDate() // Januari tahun ini
  // );

  // const [endDate, setEndDate] = React.useState(
  //   moment().startOf("month").toDate() // Bulan sekarang
  // );

  const [isMinimized, setIsMinimized] = React.useState(false);

  const defaultOption = "semua";
  const defaultIndex = years.findIndex((year) => year.value === defaultOption);
  if (defaultIndex !== -1) {
    const defaultYear = years.splice(defaultIndex, 1)[0];
    years.unshift(defaultYear);
  }
  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const sampleData = [
    { x: 1, y: 2 },
    { x: 2, y: 4 },
    { x: 3, y: 3 }, // label x = 3 akan berwarna hitam
    { x: 4, y: 5 },
    { x: 5, y: 4 },
  ];

  const dataNominal = reducerDashboard.profitNominal.map((item) => ({
    x: item.bulan,
    y: item.totalProfit,
  }));

  const dataKuantiti = reducerDashboard.profitKuantiti.map((item) => ({
    x: item.bulan,
    y: item.totalPengajuan,
  }));

  const dataTrendNominal = reducerDashboard.trendNominal.map((item) => ({
    x: item.bulan,
    y: item.totalNominal,
  }));

  const dataTrendKuantiti = reducerDashboard.trendKuantiti.map((item) => ({
    x: item.bulan,
    y: item.totalPengajuan,
  }));

  React.useEffect(() => {
    totalPenyaluran(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    totalNominalLunas(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    totalNominalOngoing(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    totalAllPengajuan(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    });
  }, [dariTgl, smpTgl]);

  // React.useEffect(() => {
  //   if (!isLoading) {
  //     totalSimpanan(dispatch, {
  //       tahun: selectedYear,
  //     });
  //   }
  // }, [selectedYear, isLoading]);

  React.useEffect(() => {
    totalSimpanan(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    getTotalKaryawan(dispatch);
    getUserTrend(dispatch);
    getPengajuanTrack(dispatch);
    getRekapSimpanan(dispatch);
    getRekapAdministrasi(dispatch);
  }, []);

  React.useEffect(() => {
    const { start, end } = selectedMonthYear;

    if (!start || !end) return;

    const tahun = moment(start).year();
    const startBulan = moment(start).month() + 1;
    const endBulan = moment(end).month() + 1;

    getProfitPugar(dispatch, {
      tahun,
      startBulan,
      endBulan,
      type: "nominal",
    });

    getProfitPugar(dispatch, {
      tahun,
      startBulan,
      endBulan,
      type: "kuantiti",
    });

    getPengajuanTrend(dispatch, {
      tahun,
      startBulan,
      endBulan,
      type: "nominal",
    });

    getPengajuanTrend(dispatch, {
      tahun,
      startBulan,
      endBulan,
      type: "kuantiti",
    });
    getNominalProfitPugar(dispatch, {
      tahun,
      startBulan,
      endBulan,
      type: "nominal",
    });
  }, [selectedMonthYear, dispatch]);

  // React.useEffect(() => {
  // if (reducerDashboard.userTrack.length > 0) {
  //   transformCombined(reducerDashboard.userTrack);
  // }
  // }, [reducerDashboard]);

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const data = payload[0].payload;

    const renderUserList = (users = []) => {
      if (users.length === 0) return null;

      const preview = users.slice(0, 5);
      const remaining = users.length - 5;

      return (
        <>
          {preview.map((u, i) => (
            <div key={i} style={{ fontSize: 12 }}>
              • {u.nama}
            </div>
          ))}
          {remaining > 0 && (
            <div style={{ fontSize: 12, fontStyle: "italic" }}>
              +{remaining} lainnya...
            </div>
          )}
        </>
      );
    };

    return (
      <div
        style={{
          background: "#fff",
          padding: "14px",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          maxWidth: 280,
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 6 }}>
          {new Date(label + "-01").toLocaleDateString("id-ID", {
            month: "long",
            year: "numeric",
          })}
          {/* {new Date(label).toLocaleDateString("id-ID", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })} */}
        </div>

        <div style={{ color: "#2563eb", marginBottom: 6 }}>
          📊 Total Active: {data.totalActive}
        </div>

        {data.join > 0 && (
          <div style={{ marginBottom: 6 }}>
            <div style={{ color: "#16a34a", fontWeight: 500 }}>
              🟢 Join: {data.join}
            </div>
            {renderUserList(data.joinUsers)}
          </div>
        )}

        {Math.abs(data.exit) > 0 && (
          <div>
            <div style={{ color: "#dc2626", fontWeight: 500 }}>
              🔴 Exit: {Math.abs(data.exit)}
            </div>
            {renderUserList(data.exitUsers)}
          </div>
        )}
      </div>
    );
  };

  const DashboardAnggotaChart = ({ data }) => {
    const formattedData = useMemo(() => {
      return data
        .filter((d) => d && d.bulan)
        .map((d) => ({
          date: d.bulan,
          totalActive: d.totalActive,
          join: d.totalJoin,
          exit: -Math.abs(d.totalExit),
          joinUsers: d.joinUsers || [],
          exitUsers: d.exitUsers || [],
        }));
    }, [data]);
    const [range, setRange] = useState({
      startIndex: 0,
      endIndex: formattedData.length - 1,
    });
    const [activeIndex, setActiveIndex] = useState(null);

    const yearDividers = useMemo(() => {
      if (!formattedData.length) return [];

      const dividers = [];

      for (let i = 1; i < formattedData.length; i++) {
        const prevYear = formattedData[i - 1].date.split("-")[0];
        const currentYear = formattedData[i].date.split("-")[0];

        if (prevYear !== currentYear) {
          dividers.push({
            year: currentYear,
            date: formattedData[i].date, // bulan pertama tahun baru
          });
        }
      }

      return dividers;
    }, [formattedData]);
    return (
      <ResponsiveContainer width="100%" height={420}>
        <ComposedChart
          data={formattedData}
          stackOffset="sign"
          margin={{ top: 5, right: 20, left: 0, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          {yearDividers.map((item) => (
            <ReferenceLine
              key={item.year}
              x={item.date}
              stroke="#94a3b8"
              strokeDasharray="4 4"
              strokeWidth={3}
              ifOverflow="extendDomain"
              yAxisId="left"
              // label={{
              //   value: item.year,
              //   position: "top",
              //   fill: "#64748b",
              //   fontSize: 12,
              //   fontWeight: 600,
              // }}
            />
          ))}

          <XAxis
            dataKey="date"
            interval={0}
            height={40}
            tick={({ x, y, payload }) => {
              const date = new Date(payload.value + "-01");
              const month = date.toLocaleDateString("id-ID", {
                month: "short",
              });
              const year = date.getFullYear().toString().slice(-2);

              return (
                <g transform={`translate(${x},${y})`}>
                  <text dy={10} textAnchor="middle" fontSize={12}>
                    {month}
                  </text>
                  <text
                    dy={20}
                    textAnchor="middle"
                    fontSize={10}
                    fill="#64748b"
                  >
                    '{year}
                  </text>
                </g>
              );
            }}
            angle={formattedData.length > 18 ? -60 : 0}
          />

          <YAxis yAxisId="left" width={60} />
          <YAxis yAxisId="right" width={60} orientation="right" />

          <RechartsTooltip content={<CustomTooltip />} />
          <Legend verticalAlign="top" />
          <ReferenceLine y={0} stroke="#000" />

          {/* Line */}
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="totalActive"
            stroke="#2563eb"
            strokeWidth={3}
            dot={{ r: 4 }}
            name="Total Active"
            isAnimationActive={true}
          />
          <defs>
            <linearGradient id="joinGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#22c55e" stopOpacity={0.9} />
              <stop offset="100%" stopColor="#15803d" stopOpacity={0.9} />
            </linearGradient>

            <linearGradient id="exitGradient" x1="0" y1="1" x2="0" y2="0">
              <stop offset="0%" stopColor="#f87171" stopOpacity={0.9} />
              <stop offset="100%" stopColor="#b91c1c" stopOpacity={0.9} />
            </linearGradient>
            <filter id="shadow" height="200%">
              <feDropShadow
                dx="0"
                dy="2"
                stdDeviation="4"
                floodOpacity="0.15"
              />
            </filter>
          </defs>
          {/* Join */}
          <Bar
            yAxisId="right"
            dataKey="join"
            fill="url(#joinGradient)"
            stackId="stack"
            barSize={38}
            radius={[8, 8, 0, 0]}
            name="Join"
            isAnimationActive
            style={{ filter: "url(#shadow)" }}
            onMouseEnter={(_, index) => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            {formattedData.map((entry, index) => (
              <Cell
                key={`join-${index}`}
                fill="url(#joinGradient)"
                fillOpacity={
                  activeIndex === null ? 0.9 : activeIndex === index ? 1 : 0.3
                }
              />
            ))}
          </Bar>

          {/* Exit */}
          <Bar
            yAxisId="right"
            dataKey="exit"
            fill="url(#exitGradient)"
            stackId="stack"
            barSize={38}
            radius={[8, 8, 0, 0]}
            name="Exit"
            isAnimationActive
            style={{ filter: "url(#shadow)" }}
            onMouseEnter={(_, index) => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            {formattedData.map((entry, index) => (
              <Cell
                key={`exit-${index}`}
                fill="url(#exitGradient)"
                fillOpacity={
                  activeIndex === null ? 0.9 : activeIndex === index ? 1 : 0.3
                }
              />
            ))}
          </Bar>

          {/* 🔥 ZOOM CONTROL */}
          <Brush
            dataKey="date"
            height={30}
            stroke="#2563eb"
            startIndex={range.startIndex}
            endIndex={range.endIndex}
            onChange={(newRange) => {
              if (newRange?.startIndex !== undefined) {
                setRange(newRange);
              }
            }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    );
  };

  const CustomTooltipPengajuan = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 rounded-lg shadow-lg border">
          <div className="font-bold">
            <b>{formatBulan(label)}</b>
          </div>
          {payload.map((item, index) => (
            <div key={index} style={{ color: item.color }}>
              {item.name}:{" "}
              {item.dataKey.includes("nominal")
                ? `Rp ${item.value.toLocaleString()}`
                : item.value}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const DashboardPengajuanCart = ({ data }) => {
    const yearSeparators = useMemo(() => {
      if (!data.length) return [];
      const dividers = [];
      for (let i = 1; i < data.length; i++) {
        const prevYear = data[i - 1].bulan.split("-")[0];
        const currentYear = data[i].bulan.split("-")[0];

        if (prevYear !== currentYear) {
          dividers.push({ year: currentYear, date: data[i].bulan });
        }
      }

      return dividers;
    }, [data]);

    return (
      <ResponsiveContainer width="100%" height={420}>
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          {yearSeparators.map((item) => (
            <ReferenceLine
              key={item.year}
              x={item.date}
              stroke="#94a3b8"
              strokeDasharray="4 4"
              strokeWidth={3}
              yAxisId="left"
            />
          ))}
          <XAxis
            dataKey="bulan"
            interval={0}
            height={40}
            tick={({ x, y, payload }) => {
              const date = new Date(payload.value + "-01");
              const month = date.toLocaleDateString("id-ID", {
                month: "short",
              });
              const year = date.getFullYear().toString().slice(-2);

              return (
                <g transform={`translate(${x},${y})`}>
                  <text dy={10} textAnchor="middle" fontSize={12}>
                    {month}
                  </text>
                  <text
                    dy={20}
                    textAnchor="middle"
                    fontSize={10}
                    fill="#64748b"
                  >
                    '{year}
                  </text>
                </g>
              );
            }}
            // angle={formattedData.length > 18 ? -60 : 0}
          />

          {/* Y Axis Nominal */}
          <YAxis
            yAxisId="left"
            tickFormatter={(val) => `${val / 1000000}jt`}
            width={60}
          />

          {/* Y Axis Status */}
          <YAxis yAxisId="right" orientation="right" width={60} />

          <RechartsTooltip content={<CustomTooltipPengajuan />} />
          <Legend />

          {/* BAR NOMINAL PENGAJUAN */}
          <Bar
            yAxisId="left"
            dataKey="nominalPengajuan"
            name="Nominal Pengajuan"
            radius={[10, 10, 0, 0]}
            barSize={30}
            fill="#6366F1"
          />

          {/* BAR NOMINAL PENCAIRAN */}
          <Bar
            yAxisId="left"
            dataKey="nominalPencairan"
            name="Nominal Pencairan"
            radius={[10, 10, 0, 0]}
            barSize={30}
            fill="#22C55E"
          />

          {/* LINE STATUS */}
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="Menunggu"
            stroke="#F59E0B"
            strokeWidth={3}
            dot={{ r: 4 }}
          />

          <Line
            yAxisId="right"
            type="monotone"
            dataKey="Diproses"
            stroke="#EF4444"
            strokeWidth={3}
            dot={{ r: 4 }}
          />

          <Line
            yAxisId="right"
            type="monotone"
            dataKey="Disetujui"
            stroke="#0EA5E9"
            strokeWidth={3}
            dot={{ r: 4 }}
          />

          <Brush
            dataKey="bulan"
            height={30}
            stroke="#6366F1"
            travellerWidth={10}
          />
        </ComposedChart>
      </ResponsiveContainer>
    );
  };

  const CustomTooltipRekapSimpanan = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const value = payload[0].value;

      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: 8,
            padding: "10px 14px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          }}
        >
          <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
          <p style={{ margin: 0, color: "#2563eb", fontWeight: 600 }}>
            Rp {value.toLocaleString("id-ID")}
          </p>
        </div>
      );
    }
    return null;
  };

  const DashboardSimpananBarChart = ({ data }) => {
    const formattedData = data.map((item) => ({
      ...item,
      month: new Date(item.date + "-01").toLocaleDateString("id-ID", {
        month: "short",
        year: "numeric",
      }),
    }));
    const yearSeparators = useMemo(() => {
      if (!data.length) return [];
      const dividers = [];
      for (let i = 1; i < data.length; i++) {
        const prevYear = data[i - 1].date.split("-")[0];
        const currentYear = data[i].date.split("-")[0];

        if (prevYear !== currentYear) {
          dividers.push({ year: currentYear, date: data[i].date });
        }
      }

      return dividers;
    }, [data]);

    return (
      <div style={{ width: "100%", height: 400 }}>
        <ResponsiveContainer>
          <BarChart
            data={formattedData}
            margin={{ top: 20, right: 20, left: 10, bottom: 40 }}
          >
            {/* gradient */}
            <defs>
              <linearGradient id="barColor" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3b82f6" stopOpacity={1} />
                <stop offset="100%" stopColor="#93c5fd" stopOpacity={0.7} />
              </linearGradient>
            </defs>

            <CartesianGrid strokeDasharray="3 3" />
            {yearSeparators.map((item) => (
              <ReferenceLine
                key={item.year}
                x={item.date}
                stroke="#94a3b8"
                strokeDasharray="4 4"
                strokeWidth={3}
                yAxisId="left"
              />
            ))}
            <XAxis
              dataKey="date"
              interval={0}
              height={40}
              tick={({ x, y, payload }) => {
                const date = new Date(payload.value + "-01");
                const month = date.toLocaleDateString("id-ID", {
                  month: "short",
                });
                const year = date.getFullYear().toString().slice(-2);

                return (
                  <g transform={`translate(${x},${y})`}>
                    <text dy={10} textAnchor="middle" fontSize={12}>
                      {month}
                    </text>
                    <text
                      dy={20}
                      textAnchor="middle"
                      fontSize={10}
                      fill="#64748b"
                    >
                      '{year}
                    </text>
                  </g>
                );
              }}
              // angle={formattedData.length > 18 ? -60 : 0}
            />

            <YAxis
              yAxisId="left"
              tickFormatter={(v) =>
                (v / 1000000).toLocaleString("id-ID") + "jt"
              }
            />

            <RechartsTooltip content={<CustomTooltipRekapSimpanan />} />

            <Bar
              yAxisId="left"
              dataKey="totalNominalBulan"
              fill="url(#barColor)"
              radius={[8, 8, 0, 0]}
              barSize={35}
              animationDuration={1200}
              animationEasing="ease-out"
            >
              {formattedData.map((entry, index) => (
                <Cell key={index} />
              ))}
            </Bar>

            {/* zoom slider */}
            <Brush
              dataKey="date"
              height={25}
              stroke="#3b82f6"
              travellerWidth={12}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const CustomTooltipRekapAdmin = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const value = payload[0].value;

      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: 8,
            padding: "10px 14px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          }}
        >
          <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
          <p style={{ margin: 0, color: "#2563eb", fontWeight: 600 }}>
            Rp {value.toLocaleString("id-ID")}
          </p>
        </div>
      );
    }
    return null;
  };

  const DashboardAdminBarChart = ({ data }) => {
    const [zoomedTotalAdmin, setZoomedTotalAdmin] = useState(0);

    const [brushIndex, setBrushIndex] = useState({
      startIndex: 0,
      endIndex: data.length > 0 ? data.length - 1 : 0,
    });

    // Format data
    const formattedData = useMemo(() => {
      return data.map((item) => ({
        ...item,
        month: new Date(item.date + "-01").toLocaleDateString("id-ID", {
          month: "short",
          year: "numeric",
        }),
      }));
    }, [data]);

    // Inisialisasi total awal
    useEffect(() => {
      if (formattedData.length > 0) {
        const total = formattedData.reduce(
          (sum, item) => sum + (item.totalAdmin || 0),
          0,
        );

        setZoomedTotalAdmin(total);

        setBrushIndex({
          startIndex: 0,
          endIndex: formattedData.length - 1,
        });
      }
    }, [formattedData]);

    // Brush change
    const handleBrushChange = (brushState) => {
      if (!brushState || brushState.startIndex === undefined) return;

      const { startIndex, endIndex } = brushState;

      setBrushIndex({ startIndex, endIndex });

      const slicedData = formattedData.slice(startIndex, endIndex + 1);

      const total = slicedData.reduce(
        (sum, item) => sum + (item.totalAdmin || 0),
        0,
      );

      setZoomedTotalAdmin(total);
    };

    // Separator tahun
    const yearSeparators = useMemo(() => {
      if (!data.length) return [];

      const dividers = [];

      for (let i = 1; i < data.length; i++) {
        const prevYear = data[i - 1].date.split("-")[0];
        const currentYear = data[i].date.split("-")[0];

        if (prevYear !== currentYear) {
          dividers.push({
            year: currentYear,
            date: data[i].date,
          });
        }
      }

      return dividers;
    }, [data]);

    return (
      <div style={{ width: "100%", height: 400 }}>
        <div
          style={{
            fontWeight: 600,
            paddingLeft: 20,
            paddingRight: 20,
            justifyContent: "center",
            display: "flex",
            fontSize: 20,
          }}
        >
          {formatCurrency(zoomedTotalAdmin)}
        </div>

        <ResponsiveContainer>
          <BarChart
            data={formattedData}
            margin={{ top: 20, right: 20, left: 10, bottom: 40 }}
          >
            <defs>
              <linearGradient id="barColor" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3b82f6" stopOpacity={1} />
                <stop offset="100%" stopColor="#93c5fd" stopOpacity={0.7} />
              </linearGradient>
            </defs>

            <CartesianGrid strokeDasharray="3 3" />

            {yearSeparators.map((item) => (
              <ReferenceLine
                key={item.year}
                x={item.date}
                stroke="#94a3b8"
                strokeDasharray="4 4"
                strokeWidth={3}
                yAxisId="left"
              />
            ))}

            <XAxis
              dataKey="date"
              interval={0}
              height={40}
              tick={({ x, y, payload }) => {
                const date = new Date(payload.value + "-01");

                const month = date.toLocaleDateString("id-ID", {
                  month: "short",
                });

                const year = date.getFullYear().toString().slice(-2);

                return (
                  <g transform={`translate(${x},${y})`}>
                    <text dy={10} textAnchor="middle" fontSize={12}>
                      {month}
                    </text>
                    <text
                      dy={20}
                      textAnchor="middle"
                      fontSize={10}
                      fill="#64748b"
                    >
                      '{year}
                    </text>
                  </g>
                );
              }}
            />

            <YAxis
              yAxisId="left"
              tickFormatter={(v) =>
                (v / 1000000).toLocaleString("id-ID") + "jt"
              }
            />

            <RechartsTooltip content={<CustomTooltipRekapAdmin />} />

            <Bar
              yAxisId="left"
              dataKey="totalAdmin"
              fill="url(#barColor)"
              radius={[8, 8, 0, 0]}
              barSize={35}
            />

            <Brush
              dataKey="date"
              height={25}
              stroke="#3b82f6"
              travellerWidth={12}
              startIndex={brushIndex.startIndex}
              endIndex={brushIndex.endIndex}
              onChange={handleBrushChange}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  React.useEffect(() => {
    getRekapReport(dispatch, {
      tgl: moment(bulanTahun).format("YYYY-MM"),
    });
  }, [bulanTahun]);
  const TableIn = () => {
    const tableStyle = {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: "0",
      background: "#fff",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      fontSize: "14px",
    };

    const thStyle = {
      padding: "12px",
      textAlign: "center",
      background: "#f8fafc",
      color: "#334155",
      fontWeight: "600",
      borderBottom: "1px solid #e2e8f0",
    };

    const tdBase = {
      padding: "12px",
      borderBottom: "1px solid #f1f5f9",
    };

    const tdLeft = {
      ...tdBase,
      textAlign: "left",
      color: "#334155",
      fontWeight: "500",
    };

    const tdCenter = {
      ...tdBase,
      textAlign: "center",
      color: "#0f172a",
    };

    const tdRight = {
      ...tdBase,
      textAlign: "right",
      color: "#0f172a",
      fontWeight: "600",
    };

    const rowStyle = {
      transition: "all 0.2s ease",
      cursor: "default",
    };

    const hoverStyle = {
      backgroundColor: "#f9fafb",
    };

    let dataIn =
      reducerDashboard.rekapReport && reducerDashboard.rekapReport.responIn;

    return (
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}></th>
            <th style={thStyle}>Jumlah</th>
            <th style={thStyle}>Nominal</th>
            <th style={thStyle}>Admin</th>
          </tr>
        </thead>
        <tbody>
          {dataIn &&
            dataIn.map((row, i) => (
              <tr
                key={i}
                style={rowStyle}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f9fafb")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <td style={tdLeft}>{row.label}</td>
                <td style={tdCenter}>{row.anggota}</td>
                <td style={tdRight}>{formatRupiah(row.nominal)}</td>
                <td style={tdRight}>{formatRupiah(row.admin)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };

  const TableOut = () => {
    const tableStyle = {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: "0",
      background: "#fff",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      fontSize: "14px",
    };

    const thStyle = {
      padding: "12px",
      textAlign: "center",
      background: "#fff1f2", // beda dikit (merah soft)
      color: "#7f1d1d",
      fontWeight: "600",
      borderBottom: "1px solid #fecdd3",
    };

    const tdBase = {
      padding: "12px",
      borderBottom: "1px solid #f1f5f9",
    };

    const tdLeft = {
      ...tdBase,
      textAlign: "left",
      color: "#334155",
      fontWeight: "500",
    };

    const tdCenter = {
      ...tdBase,
      textAlign: "center",
      color: "#0f172a",
    };

    const tdRight = {
      ...tdBase,
      textAlign: "right",
      color: "#b91c1c", // merah untuk pengeluaran
      fontWeight: "600",
    };

    let dataOut =
      reducerDashboard.rekapReport && reducerDashboard.rekapReport.responOut;
    return (
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}></th>
            <th style={thStyle}>Jumlah</th>
            <th style={thStyle}>Nominal</th>
            <th style={thStyle}>Admin</th>
          </tr>
        </thead>
        <tbody>
          {dataOut &&
            dataOut.map((row, i) => (
              <tr
                key={i}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fef2f2")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                style={{ transition: "all 0.2s ease" }}
              >
                <td style={tdLeft}>{row.label}</td>
                <td style={tdCenter}>{row.anggota}</td>
                <td style={tdRight}>{formatRupiah(row.nominal)}</td>
                <td style={tdRight}>{formatRupiah(row.admin)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };

  const renderSinkronResults = (results = []) => {
    if (!results.length) {
      return "Sinkron selesai.";
    }

    return results
      .map(
        (item) =>
          `<div style="display:flex;justify-content:space-between;gap:12px;text-align:left;margin:6px 0;">
            <span>${item.nama || item.endpoint || "-"}</span>
            <strong style="color:${item.status === "sukses" ? "#16a34a" : "#dc2626"};">
              ${item.status || "-"}
            </strong>
          </div>`,
      )
      .join("");
  };

  const submitSinkronDashboard = async () => {
    const confirm = await Swal.fire({
      title: "Sinkron Dashboard?",
      text: "Sistem akan menjalankan sinkron pengajuan harian, simpanan bulanan, dan admin tahunan.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sinkron",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          Swal.showLoading();
          return await syncDashboardCronJobs();
        } catch (error) {
          Swal.showValidationMessage(
            error.message || error.msg || "Sinkron dashboard gagal",
          );
          return false;
        }
      },
    });

    if (!confirm.isConfirmed || !confirm.value) return;

    const results = confirm.value.results || [];
    const hasFailed = results.some((item) => item.status === "gagal");

    Swal.fire({
      title: hasFailed ? "Sinkron Selesai Sebagian" : "Sinkron Berhasil",
      html: renderSinkronResults(results),
      icon: hasFailed ? "warning" : "success",
      confirmButtonText: "OK",
    });
  };

  return (
    <div className="dashboard-utama-page">
      <Card
        style={{
          // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          border: 0,
          borderRadius: 10,
          marginTop: 15,
        }}
      >
        <div style={{ maxHeight: "800px" }}>
          <Row>
            <Container className="px-2 text-center">
              <Col>
                <Row>
                  <Col className="d-flex align-items-center justify-content-start">
                    <img
                      alt="..."
                      src={require("assets/img/pugar.png").default}
                      width="auto"
                      height="150px"
                    ></img>
                  </Col>
                  <Col className="d-flex flex-column align-items-center justify-content-center text-center">
                    <h4 className="title mt-2" style={{ fontWeight: "bold" }}>
                      Bulan Tahun
                    </h4>

                    <Form.Group
                      style={{
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        width: "100%", // opsional biar input tetap full
                        maxWidth: "300px", // biar tidak terlalu lebar
                      }}
                    >
                      <ReactDatetime
                        inputProps={{
                          className: "form-control text-center", // ini biar teks input di tengah
                          placeholder: "Pilih Bulan dan Tahun",
                          readOnly: true,
                          style: {
                            cursor: "default",
                            color: "black",
                            backgroundColor: "white",
                          },
                        }}
                        onChange={(e) => {
                          setBulanTahun(e.toDate());
                          console.log(e.toDate(), "tes ambil bulan tahun");
                        }}
                        value={bulanTahun}
                        initialValue={bulanTahun}
                        dateFormat="MMMM YYYY"
                        timeFormat={false}
                      />
                    </Form.Group>
                  </Col>
                  <Col className="d-flex align-items-center justify-content-end">
                    <Button
                      variant="primary"
                      className="d-flex align-items-center"
                      onClick={submitSinkronDashboard}
                    >
                      <i className="fas fa-sync-alt mr-2"></i>
                      Sinkron
                    </Button>
                  </Col>
                </Row>
              </Col>
              {/* <Col
                      lg={{ span: 6, offset: 6 }}
                      style={{
                        marginBottom: 20,
                        // marginLeft: 10,
                        marginRight: 10,
                      }}
                    >
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="singleSelect"
                        // value={status}
                        // onChange={(selectedOption) => setStatus(selectedOption)}
                        // onChange={setStatus}
                        options={[
                          { value: "true", label: "Aktif" },
                          { value: "false", label: "Tidak Aktif" },
                        ]}
                        placeholder="Pilih"
                      />
                    </Col> */}
              <Row>
                <Col md="6">
                  <div
                    style={{
                      marginBottom: 10,
                      textTransform: "uppercase",
                      color: "#534b4bff",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "600",
                        fontSize: 24,
                        textTransform: "none",
                      }}
                    >
                      In
                    </span>
                  </div>
                  <TableIn />
                </Col>
                <Col md="6">
                  <div
                    style={{
                      marginBottom: 10,
                      textTransform: "uppercase",
                      color: "#534b4bff",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "600",
                        fontSize: 24,
                        textTransform: "none",
                      }}
                    >
                      Out
                    </span>
                  </div>
                  <TableOut />
                </Col>
              </Row>
            </Container>
            <Container
              className="dashboard-date-filter"
              style={{ marginTop: 20 }}
            >
              <Col className=" justify-content-end">
                <Row>
                  <Col md="6">
                    <h4 className="title mt-2" style={{ fontWeight: "bold" }}>
                      Tanggal Awal
                    </h4>
                    <Form.Group
                      style={{
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      }}
                    >
                      <ReactDatetime
                        inputProps={{
                          className: "form-control",
                          placeholder: "Date Picker Here",
                          readOnly: true,
                          style: {
                            cursor: "default",
                            color: "black",
                            backgroundColor: "white",
                          },
                        }}
                        onChange={(e) => {
                          (e.toDate().setHours(0, 0, 0, 0),
                            setDariTgl(e.toDate().setHours(0, 0, 0, 0)));
                        }}
                        value={dariTgl}
                        initialValue={dariTgl}
                        timeFormat={false}
                      ></ReactDatetime>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <h4 className="title mt-2" style={{ fontWeight: "bold" }}>
                      Tanggal Akhir
                    </h4>
                    <Form.Group
                      style={{
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      }}
                    >
                      <ReactDatetime
                        inputProps={{
                          className: "form-control",
                          placeholder: "Date Picker Here",
                          readOnly: true,
                          style: {
                            cursor: "default",
                            color: "black",
                            backgroundColor: "white",
                          },
                        }}
                        onChange={(e) => {
                          (e.toDate().setHours(23, 59, 0, 0),
                            setSmpTgl(e.toDate().setHours(23, 59, 0, 0)));
                        }}
                        value={smpTgl}
                        initialValue={smpTgl}
                        timeFormat={false}
                      ></ReactDatetime>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Container>
          </Row>
        </div>
      </Card>
      <Container>
        <Row>
          <Col md="6">
            <Card
              style={{
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                borderRadius: 10,
                marginLeft: 10,
              }}
            >
              <Card.Header
                className="d-none d-md-inline"
                style={{
                  backgroundColor: "#7A5DBE",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
                <Card.Title
                  as="h6"
                  style={{
                    textAlign: "center",
                    alignItems: "center",
                    marginBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  <b style={{ color: "white", fontSize: 20 }}>
                    Total Penyaluran
                  </b>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <div
                  style={{
                    fontSize: 20,
                    textAlign: "center",
                    marginTop: 10,
                    color: "#212121",
                  }}
                >
                  <div
                    style={{
                      fontSize: 20,
                      textAlign: "center",
                      marginTop: 10,
                      color: "#212121",
                    }}
                  >
                    {reducerDashboard.ambilTotalPenyaluran.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={200} />
                      </SkeletonTheme>
                    ) : (
                      formatRupiah(
                        reducerDashboard.ambilTotalPenyaluran.totalPenyaluran,
                      )
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md="6">
            <Card
              style={{
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                borderRadius: 10,
                marginRight: 10,
              }}
            >
              <Card.Header
                className="d-none d-md-inline"
                style={{
                  backgroundColor: "#7A5DBE",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
                <Card.Title
                  as="h6"
                  style={{
                    textAlign: "center",
                    alignItems: "center",
                    marginBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  <b style={{ color: "white", fontSize: 20 }}>Total Simpanan</b>
                </Card.Title>
              </Card.Header>
              <Card.Body
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <>
                  <Col
                    md="12"
                    style={{
                      fontSize: 20,
                      color: "#212121",
                      // marginLeft: 20,
                      textAlign: "center",
                    }}
                  >
                    {reducerDashboard.ambilTotalSimpanan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={120} />
                      </SkeletonTheme>
                    ) : (
                      formatRupiah(
                        reducerDashboard.ambilTotalSimpanan
                          .totalNominalSimpanan,
                      )
                    )}
                  </Col>
                </>
              </Card.Body>
            </Card>
          </Col>

          <Col md="6">
            <Card
              style={{
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                borderRadius: 10,
                marginLeft: 10,
                // marginTop: 20,
              }}
            >
              <Card.Header
                className="d-none d-md-inline"
                style={{
                  backgroundColor: "#7A5DBE",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
                <Card.Title
                  as="h6"
                  style={{
                    textAlign: "center",
                    alignItems: "center",
                    marginBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  <b style={{ color: "white" }}>Total Lunas</b>
                </Card.Title>
              </Card.Header>
              <Card.Body style={{ textAlign: "center", fontSize: 25 }}>
                {isNaN(totalJumlahLunas) ? (
                  <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                    <Skeleton height={"100%"} width={120} />
                  </SkeletonTheme>
                ) : (
                  formatRupiah(totalJumlahLunas)
                )}
              </Card.Body>
              <Row>
                <Col
                  className="p-2 d-flex justify-content-center"
                  style={{ fontWeight: "bold" }}
                >
                  Pokok
                </Col>

                <Col
                  className="p-2 d-flex justify-content-center"
                  style={{ fontWeight: "bold" }}
                >
                  Admin
                </Col>
              </Row>
              <Row>
                <Col
                  className="p-2 d-flex justify-content-center"
                  // style={{ fontWeight: "bold" }}
                >
                  {reducerDashboard.ambilTotalNominalLunas.length === 0 ? (
                    <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                      <Skeleton height={"100%"} width={90} />
                    </SkeletonTheme>
                  ) : (
                    formatRupiah(
                      reducerDashboard.ambilTotalNominalLunas.totalPokok,
                    )
                  )}
                </Col>

                <Col className="p-2 d-flex justify-content-center">
                  {reducerDashboard.ambilTotalNominalLunas.length === 0 ? (
                    <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                      <Skeleton height={"100%"} width={90} />
                    </SkeletonTheme>
                  ) : (
                    formatRupiah(
                      reducerDashboard.ambilTotalNominalLunas.totalAdmin,
                    )
                  )}
                </Col>
              </Row>
            </Card>
          </Col>

          <Col md="6">
            <Card
              style={{
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                borderRadius: 10,
                marginRight: 10,
                // marginTop: 20,
              }}
            >
              <Card.Header
                className="d-none d-md-inline"
                style={{
                  backgroundColor: "#7A5DBE",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
                <Card.Title
                  as="h6"
                  style={{
                    textAlign: "center",
                    alignItems: "center",
                    marginBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  <b style={{ color: "white" }}>Total On Going</b>
                </Card.Title>
              </Card.Header>
              <Card.Body style={{ textAlign: "center", fontSize: 25 }}>
                {isNaN(totalJumlahOnGoing) ? (
                  <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                    <Skeleton height={"100%"} width={120} />
                  </SkeletonTheme>
                ) : (
                  formatRupiah(totalJumlahOnGoing)
                )}
              </Card.Body>
              <Row>
                <Col
                  className="p-2 d-flex justify-content-center"
                  style={{ fontWeight: "bold" }}
                >
                  Pokok
                </Col>

                <Col
                  className="p-2 d-flex justify-content-center"
                  style={{ fontWeight: "bold" }}
                >
                  Admin
                </Col>
              </Row>
              <Row>
                <Col
                  className="p-2 d-flex justify-content-center"
                  // style={{ fontWeight: "bold" }}
                >
                  {reducerDashboard.ambilTotalNominalOnGoing.length === 0 ? (
                    <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                      <Skeleton height={"100%"} width={90} />
                    </SkeletonTheme>
                  ) : (
                    formatRupiah(
                      reducerDashboard.ambilTotalNominalOnGoing
                        .totalSisaBayarPokok,
                    )
                  )}
                </Col>
                <Col
                  className="p-2 d-flex justify-content-center"
                  // style={{ fontWeight: "bold" }}
                >
                  {reducerDashboard.ambilTotalNominalOnGoing.length === 0 ? (
                    <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                      <Skeleton height={"100%"} width={90} />
                    </SkeletonTheme>
                  ) : (
                    formatRupiah(
                      reducerDashboard.ambilTotalNominalOnGoing
                        .totalSisaBayarAdmin,
                    )
                  )}
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
      <Card
        style={{
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          borderRadius: 10,
        }}
      >
        <Card.Body>
          <div
            style={{
              marginBottom: 10,
              textTransform: "uppercase",
              color: "#534b4bff",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                fontSize: 24,
                textTransform: "none",
              }}
            >
              User Growth Trend
            </span>
          </div>
          <hr></hr>
          <Row>
            <Col>
              <Row>
                <DashboardAnggotaChart data={reducerDashboard.userTrack} />
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card
        style={{
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          borderRadius: 10,
        }}
      >
        <Card.Body>
          <div
            style={{
              marginBottom: 10,
              textTransform: "uppercase",
              color: "#534b4bff",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                fontSize: 24,
                textTransform: "none",
              }}
            >
              Pengajuan Growth Trend
            </span>
          </div>
          <hr></hr>
          <Row>
            <Col>
              <Row>
                <DashboardPengajuanCart
                  data={reducerDashboard.pengajuanTrack}
                />
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card
        style={{
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          borderRadius: 10,
        }}
      >
        <Card.Body>
          <div
            style={{
              marginBottom: 10,
              textTransform: "uppercase",
              color: "#534b4bff",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                fontSize: 24,
                textTransform: "none",
              }}
            >
              Trend Simpanan
            </span>
          </div>
          <hr></hr>
          <Row>
            <Col>
              <Row>
                <DashboardSimpananBarChart
                  data={reducerDashboard.rekapSimpanan}
                />
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card
        style={{
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          borderRadius: 10,
        }}
      >
        <Card.Body>
          <div
            style={{
              marginBottom: 10,
              textTransform: "uppercase",
              color: "#534b4bff",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                fontSize: 24,
                textTransform: "none",
              }}
            >
              Trend Administrasi
            </span>
          </div>
          <hr></hr>
          <Row>
            <Col>
              <Row>
                <DashboardAdminBarChart data={reducerDashboard.rekapAdmin} />
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Container fluid>
        <Row>
          <Col lg="6" sm="6">
            <h4
              className="title mt-2"
              style={{ fontWeight: "bold", textTransform: "uppercase" }}
            >
              informasi
              <hr></hr>
            </h4>
            <Row>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Total Karyawan</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.totalKaryawan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.totalKaryawan.totalUser
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Total Lunas</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalNominalLunas.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalNominalLunas
                        .jumlahPengajuanLunas
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Total Angsur</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalNominalOnGoing.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalNominalOnGoing
                        .jumlahPengajuanAngsur
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Total Anggota Koperasi</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.totalKaryawan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.totalKaryawan.anggotaKoperasi
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Bukan Anggota Koperasi</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.totalKaryawan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.totalKaryawan.bukanAnggotaKoperasi
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>User Menunggu Approve</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.totalKaryawan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.totalKaryawan.userMenungguRegister
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>User Lama Belum Register</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.totalKaryawan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.totalKaryawan.userLamaBelumRegister
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col lg="6" sm="6">
            <h4
              className="title mt-2"
              style={{ fontWeight: "bold", textTransform: "uppercase" }}
            >
              status pengajuan
              <hr></hr>
            </h4>
            <Row>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Total Pengajuan</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalAllPengajuan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalAllPengajuan.totalPengajuan
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Menunggu</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalAllPengajuan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalAllPengajuan.totalMenunggu
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Diproses</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalAllPengajuan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalAllPengajuan.totalDiproses
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Disetujui</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalAllPengajuan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalAllPengajuan.totalDisetujui
                    )}
                  </Card.Body>
                </Card>
              </Col>

              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Revisi</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalAllPengajuan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalAllPengajuan.totalRevisi
                    )}
                  </Card.Body>
                </Card>
              </Col>

              <Col lg="4" sm="6">
                <Card
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    borderRadius: 10,
                  }}
                >
                  <Card.Header
                    className="d-none d-md-inline"
                    style={{
                      backgroundColor: "#624B99",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Card.Title
                      // as="h6"
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      <b style={{ color: "white" }}>Ditolak</b>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ textAlign: "center" }}>
                    {reducerDashboard.ambilTotalAllPengajuan.length === 0 ? (
                      <SkeletonTheme color="#BDC7C9" highlightColor="#BDC7C9">
                        <Skeleton height={"100%"} width={50} />
                      </SkeletonTheme>
                    ) : (
                      reducerDashboard.ambilTotalAllPengajuan.totalDitolak
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DashboardUtama;
